<template>
    <div>
      分享海报
      <quill-edit @content="getContent" :width="800" :height="800" ></quill-edit>
    </div>
  </template>
  
  <script>
   import quillEdit from '../../components/quillEdit'
    export default {
      components: {
         
            quillEdit,
           
        },
      data() {
        //数据  
        return {
          Visible: false,
          formInline: {
            start: 0,
            length: 10,
            userId: '',
            ordersn: '',
            goodsname: '',
            userPhone: '',
            phone: '',
            refund: 0,
            status: '',
            payType: '',
            date: '',
            date2: '',
            time: []
          },
          listData: [],
          // 分页参数
          pageparm: {
            currentPage: 1,
            pageSize: 5,
            total: 10,
            start: 0,
            length: 5
          },
          replycommentForm: {}
  
        };
      },
   
      watch: {},
  
      methods: {
        getContent(content){console.log(content)},
        // 获得商品数据
        getdata(param) {
  
          if (param.time.length) {
            param.date = param.time[0]
            param.date2 = param.time[1]
          }
          console.log(param)
  
        },
        // 查询
        search() {
          this.getdata(this.formInline)
        },
        // 清空
        clear() {
          this.formInline = {
            start: 0,
            length: 10,
            userId: '',
            ordersn: '',
            goodsname: '',
            userPhone: '',
            phone: '',
            refund: 0,
            status: '',
            payType: '',
            date: '',
            date2: '',
            time: []
          }
          this.getdata(this.formInline)
        },
  
        // 分页插件事件
        callFather(parm) {
          this.pageparm.currentPage  = parm.currentPage
          this.pageparm.pageSize =  parm.pageSize 
          this.pageparm.currentPage  = parm.currentPage - 1
          this.pageparm.pageSize =  parm.pageSize 
          this.formInline.start = parm.currentPage - 1
          this.formInline.length = parm.pageSize
          this.getdata(this.formInline)
        },
        addFun() { },
        submitFun() { }
      },
      // 创建前状态(里面是操作)
      beforeCreate() { },
      // 创建完毕状态(里面是操作)
      created() { },
      // 挂载前状态(里面是操作)
      beforeMount() { },
      // 挂载结束状态(里面是操作)
      mounted() { },
      // 更新前状态(里面是操作)
      beforeUpdate() { },
      // 更新完成状态(里面是操作)
      updated() { },
      // 销毁前状态(里面是操作)
      beforeDestroy() { },
      // 销毁完成状态(里面是操作)
      destroyed() { }
    };
  </script>
  
  <style scoped>
  
  </style>